import { t } from 'i18next';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { getOrganizationSlug } from '../organizations/selectors';
import { getKEXCommunity } from './data';
import { errorReceiveKEXCommunity, failedReceiveKEXCommunity, receiveKEXCommunity } from './slice';
export function* requestKEXCommunity(action) {
    try {
        const { consumerAPI } = action.payload;
        const organizationSlug = yield select(getOrganizationSlug);
        const response = yield call(getKEXCommunity, organizationSlug, consumerAPI);
        if (!consumerAPI) {
            const { data, error } = response;
            if (error) {
                yield put(errorReceiveKEXCommunity());
            }
            else if (data && data.length > 0) {
                yield put(receiveKEXCommunity(data));
            }
            else {
                throw new Error(t('NO_DATA_AVAILABLE', {
                    ns: 'Common'
                }));
            }
        }
        else {
            if (response && response.status !== 200) {
                yield put(errorReceiveKEXCommunity());
            }
            else if (response && response.status === 200) {
                yield put(receiveKEXCommunity(response.data));
            }
            else {
                throw new Error(t('NO_DATA_AVAILABLE', {
                    ns: 'Common'
                }));
            }
        }
    }
    catch (e) {
        yield put(failedReceiveKEXCommunity());
    }
}
export function* watchRequestKEXCommunity() {
    yield takeLatest('kexCommunity/requestKEXCommunity', requestKEXCommunity);
}
